import { __assign } from "tslib";
import React from 'react';
import { SvgIcon } from './internal/SvgIcon';
export var Add = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("svg", { viewBox: "0 0 16 16" },
        React.createElement("path", { fillRule: "evenodd", d: "M9,8 L13,8 L13,10 L9,10 L9,14 L7,14 L7,10 L3,10 L3,8 L7,8 L7,4 L9,4 L9,8 Z" })))); };
